import React from "react";
import { generateCRUDRoutes } from "../../../../utils/index";
import GrievanceAndDispute from "./index";

const grievanceAndDisputeRoutes = [	
	generateCRUDRoutes({
		mainTitle: "Grievance and Dispute Resolution Policy",
		basePath: "grievance-dispute",
		mainComponent: <GrievanceAndDispute />,
	    layout: "/console",	   
	    subTitle:"Grievance and Dispute Resolution Policy",
		level:5,
		moduleId: 0,
	})
]

export default grievanceAndDisputeRoutes;